module.exports = __webpack_public_path__ + "static/media/process_1.b12497b2.svg";